// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --lego-yellow: #f2cd37;
  --lego-red: #c91a09;
  --lego-blue: #0055bf;
  --lego-white: #ffffff;
  --lego-black: #05131d;
  --lego-green: #237841;
  --lego-orange: #fe8a18;
  --lego-purple: #81007b;
  --background-color: #f5f5f5;
  --baseplate-color: #e3e3e3;
  --mobile-gutter: 0.75rem;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  font-family: Arial, sans-serif;
  background: linear-gradient(135deg, var(--background-color) 0%, #ffffff 100%);
  -webkit-text-size-adjust: 100%;
}

.app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  padding: 2rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

@media (max-width: 768px) {
  .main-content {
    padding: var(--mobile-gutter);
    padding-bottom: max(var(--mobile-gutter), env(safe-area-inset-bottom));
    align-items: stretch;
  }
}

h1 {
  color: #333;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,2BAA2B;EAC3B,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,8BAA8B;EAC9B,6EAA6E;EAC7E,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE;IACE,6BAA6B;IAC7B,sEAAsE;IACtE,oBAAoB;EACtB;AACF;;AAEA;EACE,WAAW;AACb","sourcesContent":[":root {\n  --lego-yellow: #f2cd37;\n  --lego-red: #c91a09;\n  --lego-blue: #0055bf;\n  --lego-white: #ffffff;\n  --lego-black: #05131d;\n  --lego-green: #237841;\n  --lego-orange: #fe8a18;\n  --lego-purple: #81007b;\n  --background-color: #f5f5f5;\n  --baseplate-color: #e3e3e3;\n  --mobile-gutter: 0.75rem;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: Arial, sans-serif;\n  background: linear-gradient(135deg, var(--background-color) 0%, #ffffff 100%);\n  -webkit-text-size-adjust: 100%;\n}\n\n.app {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.main-content {\n  flex: 1;\n  padding: 2rem;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n@media (max-width: 768px) {\n  .main-content {\n    padding: var(--mobile-gutter);\n    padding-bottom: max(var(--mobile-gutter), env(safe-area-inset-bottom));\n    align-items: stretch;\n  }\n}\n\nh1 {\n  color: #333;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
